
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "project-mailing-lists"
    }}>{`Project Mailing Lists`}</h1>
    <ul>
      <li parentName="ul">{`These are the mailing lists that have been established for this project. For each list, there is a - subscribe, unsubscribe, and an archive link.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Name`}</strong></th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Subscribe`}</strong></th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Unsubscribe`}</strong></th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Post`}</strong></th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Archive`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`atlas-dev`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "mailto:dev-subscribe@atlas.apache.org"
            }}>{`Subscribe`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "mailto:dev-unsubscribe@atlas.apache.org"
            }}>{`Unsubscribe`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "mailto:dev@atlas.apache.org"
            }}>{`Post`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "http://mail-archives.apache.org/mod_mbox/atlas-dev/"
            }}>{`mail-archives.apache.org`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`atlas-user`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "mailto:user-subscribe@atlas.apache.org"
            }}>{`Subscribe`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "mailto:user-unsubscribe@atlas.apache.org"
            }}>{`Unsubscribe`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "mailto:user@atlas.apache.org"
            }}>{`Post`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "http://mail-archives.apache.org/mod_mbox/atlas-user/"
            }}>{`mail-archives.apache.org`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`atlas-commits`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "mailto:commits-subscribe@atlas.apache.org"
            }}>{`Subscribe`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "mailto:commits-unsubscribe@atlas.apache.org"
            }}>{`Unsubscribe`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "mailto:commits@atlas.apache.org"
            }}>{`Post`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "http://mail-archives.apache.org/mod_mbox/atlas-commits/"
            }}>{`mail-archives.apache.org`}</a></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;